// deno-fmt-ignore-file
import { Deferred } from '../types/deferred.mjs';
import { WithAction } from '../engine/with/instantiate.mjs';
/** Creates a deferred With action. */
export function WithDeferred(type, options) {
    return Deferred('With', [type, options], {});
}
/** Applies annotation options to the given type. */
export function With(type, options) {
    return WithAction(type, options);
}
